//@ts-nocheck

import { FunctionalComponent, h } from "preact";
import { useState, useCallback } from "preact/hooks";

import styled, { css } from "styled-components";

const Row = styled.div`
  display: flex;
`;

const Tag = styled.div`
  margin: 0 2px;
`;

const TagsList = styled(Row)``;

const Wrapper = styled(Row)``;

export const Tags: FunctionalComponent = ({
  initialTags,
  allowDuplicates,
  onUpdate,
}) => {
  const [tags, setTags] = useState(initialTags || []);
  const [currentInput, setInput] = useState("");

  const handleKeyDown = useCallback(
    (e: any) => {
      if (e.key === "Enter") {
        if (!allowDuplicates) {
          const duplicate = tags.find((tag: string) => tag === e.target.value);
          if (duplicate) {
            setInput("");
            return;
          }
        }
        const updatedTags = [...tags, e.target.value];
        setTags(updatedTags);
        onUpdate(updatedTags);
        setInput("");
      }
    },
    [tags]
  );

  const handleInput = useCallback((e: any) => {
    setInput(e.target.value);
  }, []);

  const handleRemove = (index: number, tag: string) =>
    useCallback(
      (e: any) => {
        const updatedTags = tags.filter((_: string, i: number) => i !== index);
        setTags(updatedTags);
        onUpdate(updatedTags);
      },
      [tags]
    );

  return (
    <Wrapper>
      {/* <Input
                value={currentInput}
                onKeyDown={handleKeyDown}
                onChange={handleInput}
            /> */}
      <TagsList>
        {tags.map((tag: string, i: number) => (
          <Tag key={`${tag}_${i}`} onActionClick={handleRemove(i, tag)}>
            {tag}
          </Tag>
        ))}
      </TagsList>
    </Wrapper>
  );
};
